import { EnterEmail } from "./steps/EnterEmail";
import { Button, Result, Typography } from "antd"; 
import { MFAImage } from "./steps/MFAImage";
import { useWebullPayConnectContext, WebullPayConnectStep } from "../contexts/WebullPayConnectContext";
import { MFASecurityQuestion } from "./steps/MFASecurityQuestion";
import { PasswordAndPin } from "./steps/PasswordAndPin";
import { Link } from "react-router-dom";
const { Title, Text } = Typography;

const StepHeader = ({ title, description } : {
  title: string,
  description: string
}) => {
  return <div style={{ textAlign: 'center' }} >
    <Title level={2}>{title}</Title>
    <Text>{ description }</Text>
  </div>
}

export const WebullPayConnect = () => {
  const { currentStep } = useWebullPayConnectContext();
  return <div>
    {
      currentStep === WebullPayConnectStep.Email && <div>
        <StepHeader 
          title={'Enter Email'} 
          description={'Enter your webull pay email address to continue'} />
        <EnterEmail />
      </div>
    }
    {
      currentStep === WebullPayConnectStep.MFAImage && <div>
        <StepHeader 
          title={'MFA Image'} 
          description={'Move the jigsaw block to its place by adjusting the slider'} />
        <MFAImage />
      </div>
    }
       {
      currentStep === WebullPayConnectStep.MFAQuestion && <div>
        <StepHeader 
          title={'Security Question'} 
          description={'Provide Answer to security question'} />
          <MFASecurityQuestion />
      </div>
    }
      {
      currentStep === WebullPayConnectStep.PasswordAndPin && <div>
        <StepHeader 
          title={'Password and Pin'} 
          description={'Enter your password and trading pin'} />
        <PasswordAndPin />
      </div>
    }
    {
      currentStep === WebullPayConnectStep.Success && <div>
        <Result
          status="success"
          title="Webull Pay Connect Successfully"
          subTitle="You have successfully connected to Pay Webull"
          extra={[
            <Link to="/app/dashboard">
              <Button type="primary">
                Back To Dashboard
              </Button>
            </Link>
          ]}
        />
      </div>
    }
  </div>
}